import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { Container, Card, Table, Button, Alert, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faExclamationTriangle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { mFormat, formatterPeso, getFundRequestTypeValueToShow } from 'src/utils/utils';
import { DELIVERY_ORDER_LIST } from 'src/utils/constants';
import { SumCollectionAmountsOP } from '../../../utils/utils';
import ActionIcon from '../../general/ActionIcon';
import DetailModal from '../FundRequests/modal/DetailModal';
import { useProfileChecks } from 'src/components/general/menu/hooks/useProfileChecks';
import { getUserData } from 'src/services/userServices';
import { getAccessToken } from 'src/redux/login/loginReducer';

const DeliveryOrderDetailsPage = () => {
	const dispatch = useDispatch();
	const { isProfileNameSA, isProfileNameAI } = useProfileChecks();
	const { data: deliveryOrderDetailsData } = useSelector(state => state?.deliveryOrderReducer?.searchDeliveryOrderId) ?? {};
	const accessToken = useSelector(state => getAccessToken(state));
	const [show, setShow] = useState(false);
	const [activeOP, setActiveOP] = useState(false);
	const [createdByUser, setCreatedByUser] = useState(null);
	const [lastModifiedUser, setLastModifiedUser] = useState(null);

	useEffect(() => {
		if ((isProfileNameSA || isProfileNameAI) && deliveryOrderDetailsData && accessToken) {
			const createdById = deliveryOrderDetailsData.createdBy;
			const lastModifiedById = deliveryOrderDetailsData.lastModifiedBy;

			if (createdById === lastModifiedById && createdById) {
				getUserData(accessToken, createdById)
					.then(response => {
						const userData = response?.data || {
							name: `Usuario ID: ${createdById}`,
							email: 'No disponible'
						};
						setCreatedByUser(userData);
						setLastModifiedUser(userData);
					})
					.catch(error => {
						console.error('Error fetching user data:', error);
						const fallbackData = {
							name: `Usuario ID: ${createdById}`,
							email: 'Error al cargar datos'
						};
						setCreatedByUser(fallbackData);
						setLastModifiedUser(fallbackData);
					});
			} else {
				if (createdById) {
					getUserData(accessToken, createdById)
						.then(response => {
							setCreatedByUser(response?.data || {
								name: `Usuario ID: ${createdById}`,
								email: 'No disponible'
							});
						})
						.catch(error => {
							console.error('Error fetching createdBy user data:', error);
							setCreatedByUser({
								name: `Usuario ID: ${createdById}`,
								email: 'Error al cargar datos'
							});
						});
				}

				if (lastModifiedById) {
					getUserData(accessToken, lastModifiedById)
						.then(response => {
							setLastModifiedUser(response?.data || {
								name: `Usuario ID: ${lastModifiedById}`,
								email: 'No disponible'
							});
						})
						.catch(error => {
							console.error('Error fetching lastModifiedBy user data:', error);
							setLastModifiedUser({
								name: `Usuario ID: ${lastModifiedById}`,
								email: 'Error al cargar datos'
							});
						});
				}
			}
		}
	}, [deliveryOrderDetailsData?.createdBy, deliveryOrderDetailsData?.lastModifiedBy, accessToken, isProfileNameSA, isProfileNameAI]);
	const onClickBackButton = () => {
		dispatch(push(DELIVERY_ORDER_LIST))
	};
	const onClickDetail = item => {
		setActiveOP(item.paymentOrder);
		setShow(true);
	};

	return <Container fluid>
		<Card className='mb-5'>
			<Card.Header className='h6'>
				Detalles de la Orden de entrega
			</Card.Header>
			<Card.Body>
				<Table className='text-black-color' striped borderless hover responsive>
					<tbody>
						<tr>
							<td className='text-center font-weight-bold' width="40%" >
								Número:
							</td>
							<td className='text-center'>
								{deliveryOrderDetailsData?.number}/{deliveryOrderDetailsData?.year}
							</td>
						</tr>
						<tr>
							<td className='text-center font-weight-bold' width="40%" >
								Expediente:
							</td>
							<td className='text-center'>
								{`${deliveryOrderDetailsData?.administrativeDocument?.codeOrganism} - ${deliveryOrderDetailsData?.administrativeDocument?.number}/${deliveryOrderDetailsData?.administrativeDocument?.year}`}
							</td>
						</tr>
						<tr>
							<td className='text-center font-weight-bold' width="40%" >
								Fecha:
							</td>
							<td className='text-center'>
								{mFormat(deliveryOrderDetailsData?.deliveryOrderDate)}
							</td>
						</tr>
						<tr>
							<td className='text-center font-weight-bold' width="40%" >
								Descripción:
							</td>
							<td className='text-center'>
								{deliveryOrderDetailsData?.fundRequest?.description} - {getFundRequestTypeValueToShow(deliveryOrderDetailsData?.fundRequest?.fundRequestType)}
							</td>
						</tr>
						{(isProfileNameSA || isProfileNameAI) && createdByUser && (
							<tr>
								<td className='text-center font-weight-bold' width="40%">
									Creado por:
								</td>
								<td className='text-center'>
									{createdByUser.name} ({createdByUser.email})
									{deliveryOrderDetailsData.createdDate && ` - ${mFormat(deliveryOrderDetailsData.createdDate)}`}
								</td>
							</tr>
						)}
						{(isProfileNameSA || isProfileNameAI) && lastModifiedUser && (
							<tr>
								<td className='text-center font-weight-bold' width="40%">
									Último cambio realizado por:
								</td>
								<td className='text-center'>
									{lastModifiedUser.name} ({lastModifiedUser.email})
									{deliveryOrderDetailsData.lastModifiedDate && ` - ${mFormat(deliveryOrderDetailsData.lastModifiedDate)}`}
								</td>
							</tr>
						)}
					</tbody>
				</Table>
				<p className='text-black-color h6 mt-5' >
					Detalles del Pedido de Fondo
				</p>
				<Table striped hover size='sm' responsive>
					<thead>
						<tr>
							<th className='text-center py-3' width="30%" style={{ minWidth: '150px' }} >Pedido de fondo Nro</th>
							<th className='text-center py-3' width="55%" style={{ minWidth: '150px' }} >Descripción</th>
							<th className='text-center py-3' width="15%" style={{ minWidth: '150px' }} >Importe</th>
						</tr>
					</thead>
					<tbody className='text-black-color'>
						{deliveryOrderDetailsData &&
							<tr>
								<td className='text-center'>
									{deliveryOrderDetailsData?.fundRequest?.number}/{deliveryOrderDetailsData?.fundRequest?.year}
								</td>
								<td className='text-center'>
									{deliveryOrderDetailsData?.fundRequest?.description}
								</td>
								<td className='text-right'>
									{formatterPeso.format(deliveryOrderDetailsData?.amount)}
								</td>
							</tr>
						}
					</tbody>
				</Table>
				{deliveryOrderDetailsData?.fundRequest?.details?.length
					?
					<>
						{/* Provision Orders Section */}
						{deliveryOrderDetailsData?.fundRequest?.details?.some(item => item.provisionOrder) && (
							<>
								<p className='text-black-color mt-5' >
									Detalle de Órdenes de Provisión:
								</p>
								<Table striped borderless hover responsive>
									<thead>
										<tr>
											<th className='text-center' style={{ minWidth: '100px' }} >Expediente</th>
											<th className='text-center' style={{ minWidth: '100px' }} >N° Orden Provisión</th>
											<th className='text-center' style={{ minWidth: '150px' }} >Beneficiario</th>
											<th className='text-center' style={{ minWidth: '200px' }} >Descripción</th>
											<th className='text-center' style={{ minWidth: '100px' }} >Importe</th>
										</tr>
									</thead>
									<tbody className='text-black-color'>
										{deliveryOrderDetailsData?.fundRequest?.details?.filter(item => item.provisionOrder).map((item, key) => {
											const { provisionOrder } = item;
											return (
												<tr key={key}>
													<td className='text-center'>
														{provisionOrder?.administrativeDocument?.codeOrganism}-{provisionOrder?.administrativeDocument?.number}/{provisionOrder?.administrativeDocument?.year}
													</td>
													<td className='text-center'>
														{provisionOrder?.number}/{provisionOrder?.year}
													</td>
													<td className='text-center'>
														{provisionOrder?.beneficiary?.persona?.companyName || 'Sin beneficiario'}
													</td>
													<td className='text-center'>
														{provisionOrder?.description || provisionOrder?.destination}
													</td>
													<td className='text-right'>
														{formatterPeso.format(provisionOrder?.totalAmount || provisionOrder?.amount || 0)}
													</td>
												</tr>
											)
										})}
									</tbody>
								</Table>
							</>
						)}

						{/* Payment Orders Section */}
						{deliveryOrderDetailsData?.fundRequest?.details?.some(item => item.paymentOrder) && (
							<>
								<p className='text-black-color mt-5' >
									Detalle de Órdenes de pago:
								</p>
								<Table striped borderless hover responsive>
									<thead>
										<tr>
											<th className='text-center' style={{ minWidth: '100px' }} >Expediente</th>
											<th className='text-center' style={{ minWidth: '100px' }} >Orden de Pago</th>
											<th className='text-center' style={{ minWidth: '100px' }} >Descripción</th>
											<th className='text-center' style={{ minWidth: '100px' }} >Importe</th>
											<th className='text-center' style={{ minWidth: '100px' }} >Acciones</th>
										</tr>
									</thead>
									<tbody className='text-black-color'>
										{deliveryOrderDetailsData?.fundRequest?.details?.filter(item => item.paymentOrder).map((item, key) => {
											const { paymentOrder } = item;
											return (
												<tr key={key}>
													<td className='text-center'>
														{paymentOrder?.administrativeDocument?.codeOrganism}-{paymentOrder?.administrativeDocument?.number}/{paymentOrder?.administrativeDocument?.year}
													</td>
													<td className='text-center'>
														{paymentOrder?.number}/{paymentOrder?.year}
													</td>
													<td className='text-center'>
														{paymentOrder?.description}
													</td>
													<td className='text-right'>
														{formatterPeso.format(SumCollectionAmountsOP(paymentOrder?.details || []))}
													</td>
													<td className='text-center'>
														<ActionIcon toolTipText='Ver detalle' icon={faSearch} onClick={() => onClickDetail(item)} />
													</td>
												</tr>
											)
										})}
									</tbody>
								</Table>
							</>
						)}
					</>
					:
					<>
						<p className='text-black-color mt-4' >
							Detalle de los conceptos asociados:
						</p>
						<Table striped hover size="sm" responsive>
							<thead>
								<tr className='text-white-color'>
									<th className='text-center py-3' width="40%">Concepto</th>
									<th className='text-center py-3' width="30%">Tipo de Afectación</th>
									<th className='text-center py-3' width="30%">Importe</th>
								</tr>
							</thead>
							{deliveryOrderDetailsData?.fundRequest?.manualInputs?.map((item, index) => {
								return (
									<tbody className='text-black-color' key={index}>
										<tr >
											<td className='text-center'>
												{item?.description}
											</td>
											<td className='text-center'>
												{item?.affectationYear}
											</td>
											<td className='text-right'>
												{formatterPeso.format(item?.amount)}
											</td>
										</tr>
									</tbody>
								)
							})}
						</Table>
					</>}
				<div className='text-center'>
					<Button variant='primary' size='lg' className='my-3' onClick={onClickBackButton}>
						<FontAwesomeIcon icon={faArrowLeft} className='mr-2' />
						Volver
					</Button>
				</div>
			</Card.Body>
		</Card>
		<DetailModal
			showPayOrderDetailModal={show}
			setShowPayOrderDetailModal={setShow}
			activePayOrder={activeOP}
			selectedFundRequestType={deliveryOrderDetailsData?.fundRequest?.type}
		/>
	</Container>
};

export default DeliveryOrderDetailsPage;